var map = {
	"./Group 22302.png": 1086,
	"./avatar-christmas.webp": 1087,
	"./bottom-bg-christmas.webp": 1088,
	"./btn-active.png": 1089,
	"./content-deco-1.webp": 1090,
	"./content-deco-2.webp": 1091,
	"./content-deco-3.webp": 1092,
	"./content-deco-4.webp": 1093,
	"./deco-3.webp": 1094,
	"./deposit-icon.webp": 1095,
	"./home-icon-active.webp": 1096,
	"./home-icon.webp": 1097,
	"./live-icon-active.webp": 1098,
	"./live-icon.webp": 1099,
	"./master-bg.jpg": 1100,
	"./me-icon-active.webp": 1101,
	"./me-icon.webp": 1102,
	"./platform.png": 1103,
	"./platform.webp": 1104,
	"./promos-icon-active.webp": 1105,
	"./promos-icon.webp": 1106,
	"./promos.webp": 1107,
	"./service-christmas.webp": 1108,
	"./snowman.webp": 1109,
	"./sponsor-icon-active.webp": 1110,
	"./sponsor-icon.webp": 1111,
	"./title-deco-left.webp": 1112,
	"./title-deco-right.webp": 1113,
	"./tree.webp": 1114,
	"./vip-icon.webp": 1115,
	"./vip.webp": 1116,
	"./withdraw-icon.webp": 1117,
	"./wwr-img.webp": 1118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;